import { Box, Divider } from "@mui/material";
import { DatePicker } from "@/core/components/DatePicker/DatePicker";
import FlightPathBanner from "@/components/partials/FlightPathBanner";
import { BannerProps } from "@/core/types/types";

const DelayFlowHeader = ({
  originAirportData,
  destinationAirportData,
  selectedFlightDate,
  setSelectedFlightDate,
}: BannerProps) => {
  return (
    <Box
      my={2}
      sx={{
        display: "flex",
        justifyContent: "space-around",
        flexDirection: "column",
      }}
    >
      <FlightPathBanner
        originAirportData={originAirportData}
        destinationAirportData={destinationAirportData}
      />

      <Box my={2}>
        <Divider></Divider>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignSelf: "center",
        }}
      >
        <DatePicker
          value={selectedFlightDate ? selectedFlightDate : ""}
          onPreviousDateSelect={setSelectedFlightDate}
          onNextDateSelect={setSelectedFlightDate}
        />
      </Box>
    </Box>
  );
};

export default DelayFlowHeader;
